import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { mqttPublish } from 'services/mqtt-service'
import { getList, getById } from 'services/content-service'
import { MqttClientContext } from 'components/system/app'
import { contentTypeMap } from 'interfaces/contentTypeInterface'
import { MQTT_TOPIC, FEATURED_VIDEOS, GENERAL_EVENTS, SPORT_EVENTS } from 'constants/appConstants'
import { getFullDate, getTime } from 'utils/getTimeDate'
import View from './view'

const Single = ({ zone, searchMode, search, searchQuery, handleStatus }) => {
  const params = useParams()
  const contentType = params.contentType
  const contentId = params.documentId
  const contentDocumentId = params.documentId

  const mqttClient = useContext(MqttClientContext)

  const [isEvent, setIsEvent] = useState(false)
  const [isVideo, setIsVideo] = useState(false)
  const [isContentLoading, setIsContentLoading] = useState(true)
  const [isRelatedLoading, setIsRelatedLoading] = useState(true)
  const [content, setContent] = useState({})
  const [rawContent, setRawContent] = useState({})
  const [relatedContent, setRelatedContent] = useState({})
  const [time, setTime] = useState('')
  const [date, setDate] = useState('')

  const [payload, setPayload] = useState({})

  const screenSelected = JSON.parse(localStorage.getItem('screenApp'))

  const topic = `${MQTT_TOPIC}${screenSelected?.value}`

  mqttClient.on('message', (topic, message) => {
    setPayload({ topic, message: message.toString() })
  })

  const publish = (command, data) => {
    if (mqttClient && !searchMode) {
      const message = JSON.stringify({ command, data })
      mqttPublish(mqttClient, topic, message)
    }
  }

  useEffect(() => {
    setIsContentLoading(true)
    setIsRelatedLoading(true)
    let formattedContent
    getById(contentType, contentId)
      .then(result => {
        formattedContent = contentTypeMap(contentType, result, true)
        setRawContent(result)
      })
      .catch(err => console.log(err))
      .finally(() => {
        setContent(formattedContent)
        setIsContentLoading(false)
      })

    let relatedList
    getList(contentType, 1, zone)
      .then(result => (relatedList = result.data.data))
      .catch(err => console.log(err))
      .finally(() => {
        setRelatedContent(relatedList)
        setIsRelatedLoading(false)
      })

    if (contentType !== FEATURED_VIDEOS) {
      publish('showContent', { contentType, contentId, contentDocumentId })
    }
  }, [params])

  useEffect(() => {
    setIsEvent(false)
    setIsVideo(false)
    if (contentType === FEATURED_VIDEOS) {
      setIsVideo(true)
    } else if (contentType === SPORT_EVENTS || contentType === GENERAL_EVENTS) {
      setIsEvent(true)
      if (content?.time && content?.date) {
        setTime(getTime(content?.time, contentType, rawContent.data.data))
        setDate(getFullDate(content.date))
      }
    }
  }, [content])

  return (
    <View
      zone={zone}
      searchMode={searchMode}
      search={search}
      searchQuery={searchQuery}
      handleStatus={handleStatus}
      isVideo={isVideo}
      isEvent={isEvent}
      time={time}
      date={date}
      content={content}
      relatedContent={relatedContent}
      contentType={contentType}
      contentId={contentId}
      contentDocumentId={contentDocumentId}
      isContentLoading={isContentLoading}
      isRelatedLoading={isRelatedLoading}
    />
  )
}

Single.defaultProps = {
  search: {} || [],
  searchMode: false,
  handleStatus: () => {},
  searchQuery: '',
}

Single.propTypes = {
  zone: PropTypes.string.isRequired,
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  searchMode: PropTypes.bool,
  handleStatus: PropTypes.func,
  searchQuery: PropTypes.string,
}

export default Single
